import React, {Component} from 'react';
import classnames from 'classnames';
import {MoreContainer} from './style';
import {promotionMore} from '../../../utils/status'
import {isEmpty, objDeepCopy} from '../../../utils/tool'

class MoreItem extends Component {
  constructor(props) {
    super(props);
    const {noticeStatus} = promotionMore;
    const {MoreItem} = this.props.store;
    if (MoreItem) {
      this.state = MoreItem;
    } else {
      this.state = {
        noticeStatus: objDeepCopy(noticeStatus),
        currentPriceRangeStart:"",
        currentPriceRangeEnd:""
      }
    }
  }

  btnGroup = () => {
    return (
      <div className="group-container">
        <div
          onClick={() => {
            this.reset()
          }}
          className="btn-item">重置
        </div>
        <div
          className="btn-item confirm"
          onClick={() => {
            this.confirm()
          }}
        >确定
        </div>
      </div>
    )
  }

  setPriceMin = (e) => {
    let value = e && e.target.value
    if(value=='' || /^(0|[1-9][0-9]*)$/.test(value)){
      this.setState({
        currentPriceRangeStart: value,
      });
    }
  }
  setPriceMax = (e) => {
    let value = e && e.target.value
    if(value=='' || /^(0|[1-9][0-9]*)$/.test(value)){
      this.setState({
        currentPriceRangeEnd: value,
      });
    }
  }

  titleCard = (props) => {
    const {title, filterItems, children, name,currentPriceRangeStart,currentPriceRangeEnd} = props;
    const minPrice = currentPriceRangeStart === null ? '' :currentPriceRangeStart+''
    const maxPrice = currentPriceRangeEnd === null ? '' :currentPriceRangeEnd+''
    return (
      <div className="title-card">
        <h6 className="title">{title}</h6>
        {
          !filterItems &&
          (
            React.cloneElement(children)
          )
        }
        {
          name==='noticeStatus' && filterItems && filterItems.length !== 0 &&
          (
            <div className="content">
              {
                filterItems.map((filterItem, index) => {
                  return (
                    <div
                      key={filterItem.text}
                      className={classnames(["filter-item", {
                        'actived': !!filterItem.selected,
                      }])}
                      onClick={() => {
                        let newFilterItems = objDeepCopy(filterItems);
                        newFilterItems.forEach(value => {
                          value['selected'] = false
                        })
                        newFilterItems[index].selected = true;
                        this.setState({
                          [name]: newFilterItems
                        })
                      }}
                    >
                      {filterItem.text}
                    </div>
                  )
                })
              }
            </div>
          )
        }
        {
          name==='referenceValue' &&
          (
            <div className="content"> 
              <div className="filtercon_main_price">
                <input 
                  type="text" 
                  className="filtercon_price_input" 
                  placeholder="最低价(元)" 
                  maxLength="14" 
                  value={minPrice} 
                  onChange={this.setPriceMin}
                />
                <i className="filtercon_price_i"> - </i>
                <input 
                  type="text" 
                  className="filtercon_price_input" 
                  placeholder="最高价(元)" 
                  maxLength="14" 
                  value={maxPrice}
                  onChange={this.setPriceMax}
                />
              </div>
            </div>
          )
        }
      </div>
    )
  }

  reset = () => {
    const {noticeStatus} = promotionMore;
    this.setState({
      noticeStatus: objDeepCopy(noticeStatus),
      currentPriceRangeStart:"",
      currentPriceRangeEnd:""
    })
  }

  confirm = () => {
    let condition = {};
    const {noticeStatus, currentPriceRangeStart, currentPriceRangeEnd} = this.state;
    let activedArr = noticeStatus.filter((value) => value.selected);

    if (isEmpty(activedArr)) {
      // 全部为空
      condition = Object.assign(condition, {
        merchantsStatus: 'none',
      })
    } else {
      condition = Object.assign(condition, activedArr[0].condition)
    }

    condition = Object.assign(condition, {referenceLowerLimit: currentPriceRangeStart,referenceUpperLimit: currentPriceRangeEnd})
    
    // 暂存数据
    const {saveCurrData, addCondition} = this.props.store;
    saveCurrData('MoreItem', this.state);

    // 增加选择条件
    addCondition(condition, true);
    const {closeFilter} = this.props;
    closeFilter();
  }

  render() {
    const {noticeStatus,currentPriceRangeStart,currentPriceRangeEnd} = this.state;
    return (
      <MoreContainer>
        {
          this.titleCard({
            name: 'noticeStatus',
            title: '招商状态',
            filterItems: noticeStatus,
          })
        }
        {
          this.titleCard({
            name: 'referenceValue',
            title: '参考价值',
            filterItems:[],
            currentPriceRangeStart:currentPriceRangeStart,
            currentPriceRangeEnd:currentPriceRangeEnd,
          })
        }
        {
          this.btnGroup()
        }
      </MoreContainer>
    );
  }
}

export default MoreItem;

